import { FC } from "react";
import { FormattedMessage } from "react-intl";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

import { Button } from "~/components/ui/button";

interface CancelExportDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  filesSelected: number;
  onKeep: () => void;
  onDiscard: () => void;
}

export const CancelExportDialog: FC<CancelExportDialogProps> = ({
  open,
  setOpen,
  filesSelected,
  onKeep,
  onDiscard,
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage
              id="docList.cancelExportingDialog.title"
              defaultMessage="Discard Selection"
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <FormattedMessage
            id="docList.cancelExportingDialog.description"
            defaultMessage="<b>{count} files</b> selected. Exiting export mode will discard selection and cancel export."
            values={{
              count: filesSelected,
              b: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </DialogDescription>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onKeep}>
            <FormattedMessage
              id="docList.cancelExportingDialog.keep"
              defaultMessage="Keep"
            />
          </Button>
          <Button onClick={onDiscard}>
            <FormattedMessage
              id="docList.cancelExportingDialog.discard"
              defaultMessage="Discard"
            />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
